import React, { useContext, useState } from 'react';

import { SessionContext } from "../../hooks/wrappers/SessionWrapper";
import MyInput from "../shared/form/MyInput";
import MySubmit from "../shared/form/MySubmit";
import useErrors from "../../hooks/useErrors";

const Login = () => {
  const { login } = useContext(SessionContext)
  const { errors, captureErrors } = useErrors()
  const [{ email, password }, setData] = useState({
    email: "",
    password: ""
  })

  const changeInfo = (event) => setData(data => ({
    ...data,
    [event.target.name]: (event.target.value)
  }));

  const submit = (event) => {
    event.preventDefault();
    if (errors.length < 1)
      login(email, password)
    else
      alert("¡Ups!, parece que no has rellenado correctmente los campos. Comprueba que el email y la contraseña son los correctos y intente iniciar sesión de nuevo.")
  };

  return (
    <form onSubmit={submit} className="container-fluid h-100">
      <div className="row justify-content-center align-items-center h-100">
        <div className="col-12 col-md-9 col-lg-6 col-xl-4">
          <div className="row">
            <div className="col-12">
              <MyInput title="EMAIL *" type="email" name="email" value={email}
                       onChange={changeInfo} captureErrors={captureErrors} notEmpty={true} contain="@"/>
            </div>
            <div className="col-12">
              <MyInput title="CONTRASEÑA *" type="password" name="password" value={password}
                       onChange={changeInfo} captureErrors={captureErrors} notEmpty={true}/>
            </div>
            <div className="offset-md-6 col-12 col-md-6">
              <div className="row bg-primary mt-3">
                <MySubmit style={{ height: "48px" }} text="INICIAR SESIÓN"
                          className="w-100 bg-primary"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}

export default Login;
